import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import { Button, Icon } from '@homeexchange/design';

const PopupSweet = ({
    className,
    show,
    link = false,
    title,
    image,
    content,
    approvedOrPayment,
    textButton,
    underTextButton,
    href,
    closeModal,
    inlineCustomStyle = null
}) => (
    <Modal
        show={show}
        dialogClassName={`modal-pre-approve ${className}`}
        onHide={closeModal}
        bsClass="modal-sweet modal"
    >
        <button type="button" className="modal-btn-close" onClick={closeModal}>
            <Icon name="Cross" />
        </button>
        <p className="title-modal" style={inlineCustomStyle && inlineCustomStyle.title}>
            {title}
        </p>
        <img className="image-modal" style={inlineCustomStyle && inlineCustomStyle.image} src={image} />
        <div className="container-content-modal">
            <p dangerouslySetInnerHTML={{ __html: content }} />
            <Button type="button" onClick={approvedOrPayment} isFullWidth>
                {textButton}
            </Button>
            {link ? (
                <a href={href} className="link-modal">
                    {underTextButton}
                </a>
            ) : (
                <p className="under-text-button" style={inlineCustomStyle && inlineCustomStyle.footer}>
                    {underTextButton ? underTextButton : ''}
                </p>
            )}
        </div>
    </Modal>
);

PopupSweet.propTypes = {
    className: PropTypes.string,
    show: PropTypes.bool,
    link: PropTypes.bool,
    title: PropTypes.string,
    image: PropTypes.string,
    content: PropTypes.string,
    approvedOrPayment: PropTypes.func,
    textButton: PropTypes.string,
    underTextButton: PropTypes.string,
    href: PropTypes.string,
    closeModal: PropTypes.func,
    inlineCustomStyle: PropTypes.shape({
        title: PropTypes.object,
        image: PropTypes.object,
        cta: PropTypes.object,
        footer: PropTypes.object
    })
};

export default PopupSweet;
